// extracted by mini-css-extract-plugin
export default {"wrapper":"k_-z"};